import { AnyAction } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'
import {
  AlignBottom,
  ArrowCircleRight2,
  ArrowRight,
  Camera,
  Logout,
  Map,
  Send2,
} from 'iconsax-react'
import { Button } from 'primereact/button'
import React, { Dispatch, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MapGoogle from '../../../components/GoogleMap'
import {
  fetchCollectedItemsRequest,
  fetchGameCodeRequest,
  fetchLocationsOnMapRequest,
  fetchMapStyleRequest,
  fetchTeamNameRequest,
  fetchProgressRequest,
} from '../../../redux/actions/gameActions'
import { getGameSelector } from '../../../redux/selectors/gameSelectors'
import { GameState } from '../../../redux/types/game'
import LoadingSpinner from './../../../components/LoadingSpinner'
import { useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { fetchGameLocalesRequest } from './../../../redux/actions/gameActions'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import inputChangeSound from '../../../assets/audio/input-sound.wav'
import socket from '../../../utils/socketIO'
import jwt_decode from 'jwt-decode'
import { Scanner } from '@yudiel/react-qr-scanner'
import { ProgressBar } from 'primereact/progressbar'
import GameHeader from '../components/GameHeader'
import { classNames } from 'primereact/utils'
import useSound from 'use-sound'
import * as DOMPurify from 'dompurify'
import client from '../../../client'
import Loading from '../../../components/Loading'
import { showErrorNotification } from '../../../redux/actions/notificationActions'
import { decodeIframeString } from '../../../utils/decodeIframeString'

const Game = () => {
  const [score, setScore] = useState(0)
  // const [time, setTime] = useState('00:00:00')
  const [displayCheckLocation, setDisplayCheckLocation] = useState(false)
  // const [displayInventory, setDisplayInventory] = useState(false)
  // const [displaySettings, setDisplaySettings] = useState(false)
  // const [teamNameValue, setTeamNameValue] = useState('')
  // const [displayScanCode, setDisplayScanCode] = useState(false)
  const [isCameraOpened, setIsCameraOpened] = useState(false)
  const [showMapControls, setShowMapControls] = useState(true)
  const showMapControlsRef = useRef(null)
  const [showScore, setShowScore] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingGps, setIsLoadingGps] = useState(false)
  const [isStartingPuzzle, setIsStartingPuzzle] = useState(false)
  const [height, setHeight] = useState(0)
  const [gameTimerReminderDialog, setGameTimerReminderDialog] =
    useState<any>(null)
  const [gameTimerDialog, setGameTimerDialog] = useState('')
  const [dialogData, setDialogData] = useState<{
    name: string
    data: any
  } | null>(null)
  const [skipPuzzle, setSkipPuzzle] = useState(null)
  // const [timer, setTimer] = useState<boolean | string>(false)
  // const [pauseDialog, setPauseDialog] = useState(false)
  // const [startGame, setStartGame] = useState(false)

  const {
    data: {
      gameCode,
      mapStyle,
      locationsOnMap,
      gameLocales,
      collectedItems,
      teamName,
      progress,
      volumeGlobal,
      selectedLanguage,
      branding,
    },
    loading: gameLoading,
  }: GameState = useSelector(getGameSelector)
  const elementRef = useRef(null)
  // const elementRef2 = useRef(null)
  const cameraBtnRef = useRef(null)
  const dispatch: Dispatch<AnyAction> = useDispatch()
  const navigate = useNavigate()
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })
  const [inputSound] = useSound(inputChangeSound, {
    volume: volumeGlobal,
  })
  const token = localStorage.getItem('tokenCityHunt') ?? ''

  const { GameType, TeamId, HasFinalPuzzle, GameLogo, GameId, GameCode }: any =
    jwt_decode(token)
  const resizeHandler = () => {
    setHeight(window.innerHeight)
  }

  Sentry.setContext('Variables', {
    score,
    displayCheckLocation,
    isCameraOpened,
    showMapControls,
    showScore,
    isLoading,
    isLoadingGps,
    isStartingPuzzle,
    gameTimerReminderDialog,
    gameTimerDialog,
    dialogData,
    skipPuzzle,
    GameType,
    TeamId,
    HasFinalPuzzle,
    GameLogo,
    GameId,
    GameCode,
  })

  useEffect(() => {
    fetchData()
    // dispatch(fetchWelcomeScreenRequest())

    // setHeight(
    //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //   // @ts-ignore
    //   elementRef?.current?.clientHeight + elementRef2?.current?.clientHeight,
    //   // cameraBtnRef?.current?.clientHeight,
    // )
    socket.emit('join-game-timer-room', TeamId)
    socket.emit('is-any-puzzle-started', TeamId)
    socket.emit('check-if-game-time-expired', TeamId)
    socket
      .off(`rooms/roomCreated/${TeamId}`)
      .on(`rooms/roomCreated/${TeamId}`, async (questionId: number) => {
        //   eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        let localeId = selectedLanguage?.id
        if (!localeId) {
          const sessionLang = localStorage.getItem('hunt-lang')
          if (sessionLang) {
            const locale = JSON.parse(sessionLang)
            localeId = locale.id
          } else {
            const token = localStorage.getItem('tokenCityHunt') ?? ''
            await client
              .get(`Team/GetGameLocales`, {
                headers: {
                  Authorization: `Bearer ${JSON.parse(token)}`,
                },
              })
              .then((response) => {
                localeId = response.data.data[0].id
                localStorage.setItem(
                  `hunt-lang`,
                  JSON.stringify({
                    ...response.data.data[0],
                    gameId: GameId,
                    gameCode: GameCode,
                  }),
                )
              })
          }
        }

        setIsStartingPuzzle(false)
        navigate(`/game/${questionId}/${localeId}`)
      })
    socket
      .off(`rooms/gameTimerStarted/${TeamId}`)
      .on(`rooms/gameTimerStarted/${TeamId}`, () => {
        socket.emit('join-game-timer-room', TeamId)
      })

    socket
      .off(`rooms/skippedPuzzle/${TeamId}`)
      .on(`rooms/skippedPuzzle/${TeamId}`, (data: any) => {
        setSkipPuzzle(data)
      })
    socket
      .off(`rooms/roomAlreadyCreated/${TeamId}`)
      .on(
        `rooms/roomAlreadyCreated/${TeamId}`,
        async (questionId: number | null) => {
          setIsLoading(true)

          if (questionId) {
            //   eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            let localeId = selectedLanguage?.id
            if (!localeId) {
              const sessionLang = localStorage.getItem('hunt-lang')
              if (sessionLang) {
                const locale = JSON.parse(sessionLang)
                localeId = locale.id
              } else {
                const token = localStorage.getItem('tokenCityHunt') ?? ''
                await client
                  .get(`Team/GetGameLocales`, {
                    headers: {
                      Authorization: `Bearer ${JSON.parse(token)}`,
                    },
                  })
                  .then((response) => {
                    localeId = response.data.data[0].id
                    localStorage.setItem(
                      `hunt-lang`,
                      JSON.stringify({
                        ...response.data.data[0],
                        gameId: GameId,
                        gameCode: GameCode,
                      }),
                    )
                  })
              }
            }
            setIsLoading(false)
            setIsStartingPuzzle(false)
            navigate(`/game/${questionId}/${localeId}`)
          }
          setIsLoading(false)
        },
      )

    socket
      .off(`rooms/solvedPuzzle/${TeamId}`)
      .on(`rooms/solvedPuzzle/${TeamId}`, () => {
        fetchMinimalData()
      })

    socket
      .off('game-timer-countdown')
      .on('game-timer-countdown', async (data: any) => {
        if (data.currentTime > 0) {
          if (data.currentTime === data.timerTime - data.timerEndReminderTime) {
            setGameTimerReminderDialog(data)
          }
        } else {
          let description = data.timerDescription

          if (description.includes('[teamName]')) {
            await client
              .get(`Team/GetTeamName`, {
                headers: {
                  Authorization: `Bearer ${JSON.parse(token)}`,
                },
              })
              .then((responseTeamName) => {
                let teamName = responseTeamName.data.data
                description = description.replace('[teamName]', teamName)
                setGameTimerDialog(description)
              })
          } else {
            setGameTimerDialog(description)
          }
        }
      })

    socket.on(
      `rooms/checkGameTimerTimeExpired/${TeamId}`,
      (isTimeExpired: boolean) => {
        if (isTimeExpired) {
          setGameTimerDialog(t('Loading'))
          const getTimerData = async () => {
            await client
              .get('Team/EndTimer', {
                headers: {
                  Authorization: `Bearer ${JSON.parse(token)}`,
                },
              })
              .then(async (response) => {
                if (response.data.data.timerTime) {
                  let description = response.data.data.timerDescription

                  if (description.includes('[teamName]')) {
                    if (!teamName) {
                      await client
                        .get(`Team/GetTeamName`, {
                          headers: {
                            Authorization: `Bearer ${JSON.parse(token)}`,
                          },
                        })
                        .then((responseTeamName) => {
                          let teamName = responseTeamName.data.data
                          description = description.replace(
                            '[teamName]',
                            teamName,
                          )
                          setGameTimerDialog(description)
                        })
                    } else {
                      description = description.replace('[teamName]', teamName)
                      setGameTimerDialog(description)
                    }
                  } else {
                    setGameTimerDialog(description)
                  }
                }
              })
          }
          getTimerData()
        }
      },
    )

    window.addEventListener('resize', () => resizeHandler)
    return () => {
      window.removeEventListener('resize', resizeHandler)
    }
  }, [])

  useEffect(() => {
    if (isCameraOpened) {
      setHeight(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        elementRef?.current?.clientHeight +
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // elementRef2?.current?.clientHeight +
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          cameraBtnRef?.current?.clientHeight,
        // cameraBtnRef?.current?.clientHeight,
      )
    }
  }, [isCameraOpened])

  useEffect(() => {
    if (elementRef.current) {
      setHeight(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        elementRef?.current?.clientHeight,
      )
    }
  }, [elementRef.current])

  useEffect(() => {
    if (locationsOnMap) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const score = locationsOnMap.reduce(
        (accumulator: number, location: any) => {
          return accumulator + location.pointsEarned
        },
        0,
      )
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // const timePassed = locationsOnMap.reduce(
      //   (accumulator: number, location: any) => {
      //     return accumulator + location.solvedTimeInSeconds
      //   },
      //   0,
      // )

      // if (timePassed !== 0) {
      //   const duration = intervalToDuration({
      //     start: 0,
      //     end: timePassed * 1000,
      //   })

      //   const zeroPad = (num: any) => String(num).padStart(2, '0')

      //   // const formatted = [duration.hours, duration.minutes, duration.seconds]
      //   //   .map(zeroPad)
      //   //   .join(':')

      //   // setTime(formatted)
      // }
      setScore(score)
    }
  }, [locationsOnMap])

  const fetchData = () => {
    if (GameType !== 'Indoor') {
      dispatch(fetchMapStyleRequest())
      dispatch(fetchLocationsOnMapRequest())
    }

    dispatch(fetchGameLocalesRequest(GameId))
    dispatch(fetchGameCodeRequest())
    dispatch(fetchTeamNameRequest())
    dispatch(fetchProgressRequest())

    // if (HasFinalPuzzle.toLowerCase() === 'true') {
    //   dispatch(fetchCollectedItemsRequest())
    // }
  }

  const fetchMinimalData = () => {
    if (GameType !== 'Indoor') {
      dispatch(fetchLocationsOnMapRequest())
    }
    dispatch(fetchProgressRequest())

    // if (HasFinalPuzzle.toLowerCase() === 'true') {
    //   dispatch(fetchCollectedItemsRequest())
    // }
  }

  const checkIfUserIsOnLocation = async (location: any) => {
    // console.log(location)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // const nextLocation = locationsOnMap.find((x: any) => !x.isPuzzleSolved)
    // setDialogData({ name: 'StartPuzzle', data: location })
    // onClick('displayCheckLocation')
    // return
    if (location) {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
      }
      setIsLoadingGps(true)
      setDialogData({ name: 'LoadingGps', data: t('Loading...') })
      onClick('displayCheckLocation')
      // await navigator.geolocation.getCurrentPosition(
      //   (pos: any) => {
      //     calculateDistance(location, pos.coords)
      //   },
      //   error,
      //   options,
      // )

      // try {
      //   const position = await new Promise<GeolocationPosition>(
      //     (resolve, reject) => {
      //       navigator.geolocation.getCurrentPosition(resolve, reject, options)
      //     },
      //   )

      //   calculateDistance(location, position.coords)
      // } catch (error) {
      //   onHide('displayCheckLocation')
      //   alert(t('AlertGps'))
      //   console.error('checkIfUserIsOnLocation error:', error)
      // } finally {
      //   setIsLoadingGps(false)
      // }

      const maxRetries = 3
      let retries = 0

      const getLocation = async () => {
        try {
          const position = await new Promise<GeolocationPosition>(
            (resolve, reject) => {
              navigator.geolocation.getCurrentPosition(resolve, reject, options)
            },
          )

          calculateDistance(location, position.coords)
          setIsLoadingGps(false)
        } catch (error: any) {
          Sentry.captureException(error)
          if (retries < maxRetries) {
            retries++
            // Retry getCurrentPosition
            getLocation()
            // return;
          } else {
            //setIsLoadingGps(false)
            if (error.code == 1) {
              setDialogData({
                name: 'LoadingGps',
                data: `You've decided not to share your position, but it's OK. We won't ask you again. Additional info: ${error.message}`,
              })
            } else if (error.code == 2) {
              setDialogData({
                name: 'LoadingGps',
                data: `The network is down or the positioning service can't be reached, please try again. Additional info: ${error.message}`,
              })
            } else if (error.code == 3) {
              setDialogData({
                name: 'LoadingGps',
                data: `The attempt timed out before it could get the location data, please try again. Additional info: ${error.message}`,
              })
            } else {
              setDialogData({
                name: 'LoadingGps',
                data: `Geolocation failed due to unknown error, please try again. Additional info: ${error.message}`,
              })
            }
          }
          // onHide('displayCheckLocation');
          // alert(t('AlertGps'));
          // console.error('checkIfUserIsOnLocation error:', error);
        }
      }

      getLocation()
    }
  }

  // function success(pos: any) {
  //   if (locationsOnMap) {
  //     if (GameType !== 'NonLinear') {
  //       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //       // @ts-ignore
  //       const nextLocation = locationsOnMap.find((x: any) => !x.isPuzzleSolved)

  //       if (!nextLocation) {
  //         setDialogData({ name: 'NoMoreLocations', data: null })
  //         onClick('displayCheckLocation')
  //         return
  //       }

  //       let isOnLocation = false
  //       isOnLocation = calculateDistance(nextLocation, pos.coords)

  //       if (!isOnLocation) {
  //         setDialogData({ name: 'NotOnLocation', data: nextLocation })
  //         onClick('displayCheckLocation')
  //       }
  //       // console.log(nextLocation)
  //     } else {
  //       let isOnLocation = false
  //       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //       // @ts-ignore
  //       for (const location of locationsOnMap) {
  //         isOnLocation = calculateDistance(location, pos.coords)

  //         if (isOnLocation) {
  //           break
  //         }
  //       }
  //       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //       // @ts-ignore
  //       const hasMoreLocations = locationsOnMap.some((x) => !x.isPuzzleSolved)
  //       if (!hasMoreLocations) {
  //         setDialogData({ name: 'NoMoreLocations', data: null })
  //         onClick('displayCheckLocation')
  //         return
  //       }

  //       if (!isOnLocation) {
  //         setDialogData({ name: 'NotOnLocation', data: location })
  //         onClick('displayCheckLocation')
  //         return
  //       }
  //     }
  //   }
  // }

  function error(err: any) {
    console.warn(`ERROR(${err.code}): ${err.message}`)
  }

  function calculateDistance(location: any, coords: any) {
    // const origin = new window.google.maps.LatLng(
    //   coords.latitude,
    //   coords.longitude,
    // )
    // const destination = new window.google.maps.LatLng(
    //   location.latitude,
    //   location.longitude,
    // )
    if (location.isPuzzleSolved) {
      setDialogData({ name: 'PuzzleIsSolved', data: null })
      onClick('displayCheckLocation')
      setIsLoadingGps(false)
      return
    }
    // const destination = new window.google.maps.LatLng(59.286557, 18.088858)
    const distance = google.maps.geometry.spherical.computeDistanceBetween(
      new google.maps.LatLng(coords.latitude, coords.longitude),
      new google.maps.LatLng(location.latitude, location.longitude),
    )
    if (
      distance <
      (location.unit === 'm'
        ? location.triggerRadius
        : location.triggerRadius * 0.3048)
    ) {
      // moze da startuje puzzle
      // console.log('moze')

      setDialogData({ name: 'StartPuzzle', data: location })
      onClick('displayCheckLocation')
    } else {
      setDialogData({ name: 'NotOnLocation', data: location })
      onClick('displayCheckLocation')
    }
    setIsLoadingGps(false)
    // const service = new window.google.maps.DistanceMatrixService()
    // service
    //   .getDistanceMatrix({
    //     origins: [origin],
    //     destinations: [destination],
    //     travelMode: window.google.maps.TravelMode.WALKING,
    //     unitSystem: window.google.maps.UnitSystem.METRIC,
    //   })
    //   .then((response) => {
    //     // console.log(response.rows[0].elements[0].distance.value)

    //   })
    //   .catch((ex) => console.log(ex))
  }

  // const distanceResponse = (response: any, status: any) => {}

  // const items = [
  //   {
  //     label: 'Inventory',
  //     icon: (
  //       <Map1 color="var(--primary-color)" variant="Bulk" className="mr-2" />
  //     ),
  //     command: () => {
  //       setDisplayInventory(true)
  //       dispatch(fetchCollectedItemsRequest())
  //       // setActiveIndex(1)
  //     },
  //   },
  //   {
  //     label: 'Settings',
  //     icon: (
  //       <Setting2
  //         color="var(--primary-color)"
  //         variant="Bulk"
  //         className="mr-2"
  //       />
  //     ),
  //     command: () => {
  //       setDisplaySettings(true)
  //       // setActiveIndex(1)
  //     },
  //   },
  //   {
  //     label: 'QR Login',
  //     icon: (
  //       <ScanBarcode
  //         color="var(--primary-color)"
  //         variant="Bulk"
  //         className="mr-2"
  //       />
  //     ),
  //     command: () => {
  //       setDisplayScanCode(true)
  //       // setActiveIndex(1)
  //     },
  //   },
  // ]

  const onClick = (name: string) => {
    // const onClick = (name: string, position: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dialogFuncMap[`${name}`](true)

    // if (position) {
    //     setPosition(position);
    // }
  }

  const dialogFuncMap = {
    displayCheckLocation: setDisplayCheckLocation,
    // displayInventory: setDisplayInventory,
    // displaySettings: setDisplaySettings,
    // displayScanCode: setDisplayScanCode,
  }

  const onHide = (name: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dialogFuncMap[`${name}`](false)
    inputSound()
  }

  const getLocaleIdFromCode = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const locale = gameLocales?.find(
      (x: any) => x.code.toLowerCase() === language.toLowerCase(),
    )

    if (locale) return locale.id

    return null
  }

  const checkDialogData = () => {
    if (dialogData?.name === 'LoadingGps') {
      return <p>{dialogData?.data}</p>
    }
    if (dialogData?.name === 'StartPuzzle') {
      return (
        <>
          <p>{t('YouAreOnGoodSpot')}</p>
          {dialogData?.data?.locationTrigger === 1 ? (
            <>
              <p>{t('YouCanStartPuzzle')}</p>
              <Button
                label={t('Start')}
                // icon={
                //   <Send2
                //     // size="32"
                //     color="#fff"
                //     variant="Bold"
                //     className="mr-1"
                //   />
                // }
                icon={
                  <>
                    <div
                      className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                      style={{
                        backgroundColor: branding?.buttonPrimary.textColor,
                      }}
                    >
                      {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                    </div>
                    <Send2
                      color={branding?.buttonPrimary.backgroundColor}
                      variant="Bold"
                      className="icon-center"
                      // className="p-button-icon p-c p-button-icon-right"
                    />
                  </>
                }
                loading={isStartingPuzzle}
                onClick={() => {
                  setIsStartingPuzzle(true)
                  socket.emit(
                    'create-room',
                    TeamId,
                    Number(dialogData?.data?.puzzleTime) * 60,
                    dialogData?.data?.questionCustomId,
                  )
                  // socket.emit('set-timer-action', 'resume', TeamId)
                  clickSound()
                }}
                autoFocus
                className="p-button-rounded w-full"
                style={{
                  backgroundColor: branding?.buttonPrimary.backgroundColor,
                  color: branding?.buttonPrimary.textColor,
                }}
                // className="p-button-rounded w-full sign-in-btn"
              />
            </>
          ) : (
            <>
              <p>{t('ScanQRToStartPuzzle')}</p>
              <div
                className="w-100"
                style={{
                  width: '100%',
                  height: '50vh',
                  position: 'relative',
                }}
              >
                <Scanner
                  onScan={(results: any) => {
                    if (results && results.length > 0) {
                      const questionId = dialogData?.data?.questionCustomId
                      const puzzleTime = Number(dialogData?.data?.puzzleTime)

                      const checkIfPuzzleCanBeStarted = async () => {
                        await client
                          .get(
                            `Team/CheckIfPuzzleCanBeStartedAsync/${questionId}`,
                            {
                              headers: {
                                Authorization: `Bearer ${JSON.parse(token)}`,
                              },
                            },
                          )
                          .then((response) => {
                            if (response.data.data.canStart) {
                              socket.emit('check-if-team-is-removed', TeamId)
                              socket.emit(
                                'create-room',
                                TeamId,
                                puzzleTime * 60,
                                questionId,
                              )
                            } else {
                              dispatch(
                                showErrorNotification(
                                  t(response.data.data.message),
                                ),
                              )
                            }
                          })
                      }

                      checkIfPuzzleCanBeStarted().catch((err) => {
                        Sentry.captureException(err)
                        dispatch(showErrorNotification(err))
                      })
                    }
                  }}
                  onError={(error) => {
                    console.info(error)
                  }}
                  constraints={{
                    facingMode: 'environment',
                  }}
                  styles={{
                    container: { width: '100%', height: '100%' },
                    video: {
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    },
                  }}
                />
              </div>
            </>
          )}
        </>
      )
    }
    if (dialogData?.name === 'NotOnLocation') {
      return (
        <Trans
          i18nKey="NotOnLocation"
          defaults="Hmm, it seems that you are not near location. Please make sure that you are at least <bold>{{radius}}{{unit}}</bold> of pin shown on map"
          values={{
            radius: dialogData?.data?.triggerRadius,
            unit: dialogData?.data?.unit,
          }}
          components={{ bold: <strong /> }}
        />
      )
    }
    if (dialogData?.name === 'PuzzleIsSolved') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (locationsOnMap?.some((location: any) => !location.isPuzzleSolved)) {
        return <p>{t('PuzzleAlreadySolved')}</p>
      } else {
        return <p>{t('AlreadyFinishedPuzzle')}</p>
      }
    }
    if (dialogData?.name === 'NoMoreLocations') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return <p>{t('NoMorePuzzles')}</p>
    }
  }

  const sanitizedData = (data: string) => ({
    __html: DOMPurify.sanitize(data, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['src', 'class', 'allowfullscreen', 'frameborder'],
    }),
  })

  const renderButton = (puzzle: any) => {
    const endScreenBtn = (
      <div style={{ width: '100%' }} className="flex justify-content-center">
        <Button
          label={t('FinishGame')}
          onClick={() => {
            clickSound()
            navigate('/end')
          }}
          type="button"
          // icon={<AlignBottom color="#fff" variant="Bold" className="mr-1" />}
          icon={
            <>
              <div
                className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                style={{
                  backgroundColor: branding?.buttonPrimary.textColor,
                }}
              >
                {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
              </div>
              <ArrowRight
                color={branding?.buttonPrimary.backgroundColor}
                className="icon-center"
                // className="p-button-icon p-c p-button-icon-right"
              />
            </>
          }
          className="p-button-rounded mt-5 p-button-raised w-full uppercase"
          style={{
            backgroundColor: branding?.buttonPrimary.backgroundColor,
            color: branding?.buttonPrimary.textColor,
          }}
          // className="p-button-rounded mt-5 p-button-raised w-full sign-in-btn"
        />
      </div>
    )

    if (puzzle.isFinalPuzzle) {
      // go to end screen

      return endScreenBtn
    } else if (puzzle.isLastPuzzle) {
      if (HasFinalPuzzle.toLowerCase() === 'true') {
        const localeId = getLocaleIdFromCode()
        // go to final puzzle description screen
        return (
          <div
            style={{ width: '100%' }}
            className="flex justify-content-center"
          >
            <Button
              label={t('GoToFinalPuzzle')}
              onClick={() => {
                clickSound()
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                navigate(`final-puzzle/${selectedLanguage.id}`)
              }}
              type="button"
              // icon={
              //   <ArrowCircleRight2
              //     color="#fff"
              //     variant="Bold"
              //     className="mr-1"
              //   />
              // }
              icon={
                <>
                  <div
                    className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                    style={{
                      backgroundColor: branding?.buttonPrimary.textColor,
                    }}
                  >
                    {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                  </div>
                  <ArrowCircleRight2
                    color={branding?.buttonPrimary.backgroundColor}
                    variant="Bold"
                    className="icon-center"
                    // className="p-button-icon p-c p-button-icon-right"
                  />
                </>
              }
              className="p-button-rounded mt-5 p-button-raised w-full"
              style={{
                backgroundColor: branding?.buttonPrimary.backgroundColor,
                color: branding?.buttonPrimary.textColor,
              }}
              // className="p-button-rounded mt-5 p-button-raised w-full sign-in-btn"
            />
          </div>
        )
      } else {
        // go to end screen
        return endScreenBtn
      }
    } else {
      // btn back to map

      return (
        <div style={{ width: '100%' }} className="flex justify-content-center">
          <Button
            label={
              GameType !== 'Indoor' ? t('BackToMap') : t('BackToMainScreen')
            }
            onClick={() => {
              clickSound()
              window.location.reload()
            }}
            type="button"
            // icon={<Map color="#fff" variant="Bold" className="mr-1" />}
            icon={
              <>
                <div
                  className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                  style={{
                    backgroundColor: branding?.buttonPrimary.textColor,
                  }}
                >
                  {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                </div>
                <Map
                  color={branding?.buttonPrimary.backgroundColor}
                  variant="Bold"
                  className="icon-center"
                  // className="p-button-icon p-c p-button-icon-right"
                />
              </>
            }
            className="p-button-rounded mt-5 p-button-raised  w-full"
            style={{
              backgroundColor: branding?.buttonPrimary.backgroundColor,
              color: branding?.buttonPrimary.textColor,
            }}
            // className="p-button-rounded mt-5 p-button-raised  w-full sign-in-btn"
          />
        </div>
      )
    }
  }

  if (skipPuzzle) {
    window.scrollTo(0, 0)
    // if (displayWellDone) {
    // socket.disconnect()
    return (
      <>
        <div
          className="flex flex-wrap justify-content-between"
          id="game-puzzle"
          style={{ height: '100%', width: '100%' }}
        >
          <div className="p-3" style={{ height: '100%', width: '100%' }}>
            <div
              style={{ overflowWrap: 'break-word' }}
              className="img-full-width ql-editor"
              dangerouslySetInnerHTML={sanitizedData(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                decodeIframeString(skipPuzzle?.skipHtml ?? '') ?? '',
              )}
            />
            {HasFinalPuzzle.toLowerCase() === 'true' &&
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              !skipPuzzle?.isFinalPuzzle && (
                <div className="flex justify-content-center w-full">
                  <img
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    src={skipPuzzle?.collectedItemImageUrl}
                    // src="/assets/layout/images/logo.png"
                    alt="inventory"
                    // className="md:ml-auto block md:h-full"
                    // className="mx-auto"
                    style={{
                      // clipPath: 'polygon(8% 0, 100% 0%, 100% 100%, 0 100%)',
                      // width: 'inherit',
                      maxWidth: '100%',
                      textAlign: 'center',
                    }}
                  />
                </div>
              )}
            {renderButton(skipPuzzle)}
          </div>
        </div>
      </>
    )
  }

  if (gameTimerDialog) {
    return (
      <Dialog
        header={t('GameTimeExpired')}
        visible={Boolean(gameTimerDialog)}
        style={{ width: '94vw', height: '30%' }}
        closable={false}
        onHide={() => null}
        headerStyle={{
          backgroundColor: branding?.modals.backgroundColor,
          color: branding?.modals.textColor,
        }}
      >
        <div className="flex flex-column text-center justify-content-center align-items-center">
          <p>{gameTimerDialog}</p>
        </div>
        <div style={{ width: '100%' }} className="flex justify-content-center">
          <Button
            label={t('FinishGame')}
            onClick={() => {
              clickSound()
              navigate('/end')
            }}
            type="button"
            // icon={<AlignBottom color="#fff" variant="Bold" className="mr-1" />}
            icon={
              <>
                <div
                  className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                  style={{
                    backgroundColor: branding?.buttonPrimary.textColor,
                  }}
                >
                  {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                </div>
                <ArrowRight
                  color={branding?.buttonPrimary.backgroundColor}
                  className="icon-center"
                  // className="p-button-icon p-c p-button-icon-right"
                />
              </>
            }
            className="p-button-rounded mt-5 p-button-raised w-full uppercase"
            style={{
              backgroundColor: branding?.buttonPrimary.backgroundColor,
              color: branding?.buttonPrimary.textColor,
            }}
            // className="p-button-rounded mt-5 p-button-raised w-full sign-in-btn"
          />
        </div>
      </Dialog>
    )
  }

  const loadingAssets =
    GameType !== 'Indoor' && (gameLoading.isLoadingMapStyle || !locationsOnMap)
  if (isLoading || loadingAssets) {
    return <Loading />
  }

  return (
    <div
      className="text-center"
      style={{ height: window.innerHeight, overflow: 'hidden' }}
    >
      {gameTimerReminderDialog && (
        <Dialog
          header={t('GameTimeReminder')}
          visible={Boolean(gameTimerReminderDialog)}
          style={{ width: '94vw', height: '30%' }}
          onHide={() => setGameTimerReminderDialog(null)}
          headerStyle={{
            backgroundColor: branding?.modals.backgroundColor,
            color: branding?.modals.textColor,
          }}
        >
          <div className="flex flex-column text-center justify-content-center align-items-center">
            <p>
              <Trans
                i18nKey="TimeWillExpireIn"
                defaults="Your game time will expire in <bold>{{time}}</bold> minutes!"
                /* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore */
                values={{
                  time:
                    (gameTimerReminderDialog.timerTime -
                      gameTimerReminderDialog.timerEndReminderTime) /
                    60,
                }}
                components={{ bold: <strong /> }}
              />
            </p>
          </div>
        </Dialog>
      )}
      <div ref={elementRef}>
        {/* <div style={{ height: '30%' }}> */}
        <GameHeader
          collectedItems={collectedItems}
          gameLoading={gameLoading}
          gameLogo={GameLogo}
          gameCode={gameCode}
          hasInventory={HasFinalPuzzle.toLowerCase() === 'true'}
          teamName={teamName}
          showMapControls={showMapControls}
          showMapControlsRef={showMapControlsRef}
          setShowMapControls={setShowMapControls}
          volumeGlobal={volumeGlobal}
          gameType={GameType}
          showScore={showScore}
          setShowScore={setShowScore}
        />
      </div>
      {GameType !== 'Indoor' ? (
        <>
          <MapGoogle
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            cityName={mapStyle?.cityName}
            markers={locationsOnMap ?? []}
            icon={null}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            mapStyle={JSON.parse(mapStyle?.mapStyle ?? '[]') ?? null}
            mapHeight={height}
            checkIfUserIsOnLocation={checkIfUserIsOnLocation}
            getLocaleIdFromCode={getLocaleIdFromCode}
            showMapControls={showMapControls}
            showMapControlsRef={showMapControlsRef}
            showScore={showScore}
            volumeGlobal={volumeGlobal}
            selectedLanguage={selectedLanguage}
            isLoadingGps={isLoadingGps}
            branding={branding}
          />
          {/* )} */}
          {showScore && (
            <div
              style={{
                // width: '95.5%',
                width: `calc(${window.innerWidth}px - 1.4rem)`,
                // width: '90%',
                position: 'absolute',
                bottom: '1.5rem',
                left: '1.2rem',
                backgroundColor: branding?.progress.backgroundColor,
                // left: '2rem',
                // left: '50%',
                // transform: 'translateX(-50%)',
              }}
              // onClick={() => setShowScore(false)}
              // className={`grid bg-white border-round ${
              //   showScore ? 'fadeinleft' : 'fadeoutleft'
              // } animation-duration-1000`}
              className={classNames(
                { fadeinleft: showScore, fadeoutleft: !showScore },
                'grid border-round animation-duration-1000',
              )}
            >
              <div className="col">
                <div className="flex justify-content-between align-items-center">
                  <div className="text-left">
                    <p
                      className="m-0"
                      style={{ color: branding?.progress.textColor }}
                    >
                      {t('SolvedPuzzles')}{' '}
                      <strong>
                        {progress?.solvedPuzzles}/{progress?.puzzlesCount}
                      </strong>
                    </p>
                    <small style={{ color: branding?.progress.primary }}>
                      <strong>{progress?.percentage}%</strong>
                    </small>
                  </div>
                  <div
                    style={{
                      background: branding?.progress.secondary,
                      color: branding?.progress.primary,
                      fontWeight: 'bold',
                    }}
                    className="p-2 border-round"
                  >
                    {progress?.score}
                  </div>
                </div>
                <ProgressBar
                  showValue={false}
                  className="mt-2"
                  value={progress?.percentage}
                  // unit="poits"
                  style={{ height: '.5rem' }}
                ></ProgressBar>
              </div>
              {/* <div className="col-4" onClick={() => setDisplayInventory(true)}>
                <div className="flex justify-content-between align-items-center">
                  <p className="m-0">Inventory</p>
                </div>
                <div
                  style={{
                    textAlign: 'left',
                    fontSize: '8vw',
                    color: 'var(--secondary-color)',
                  }}
                >
                  <strong>1/3</strong>
                </div>
              </div> */}
            </div>
          )}
        </>
      ) : !isCameraOpened ? (
        <div
          className="flex flex-column justify-content-center align-items-center p-3"
          style={{ height: `calc(${window.innerHeight - height}px - 1rem)` }}
        >
          <h6>{t('FindQRCode')}</h6>
          <Button
            label={t('OpenCamera')}
            className="p-button-rounded w-full"
            // icon={
            //   <Camera
            //     // size="55"
            //     color="#fff"
            //     variant="Bold"
            //     className="mr-2"
            //   />
            // }
            icon={
              <>
                <div
                  className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                  style={{
                    backgroundColor: branding?.buttonPrimary.textColor,
                  }}
                >
                  {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                </div>
                <Camera
                  color={branding?.buttonPrimary.backgroundColor}
                  variant="Bold"
                  className="icon-center"
                  // className="p-button-icon p-c p-button-icon-right"
                />
              </>
            }
            onClick={() => {
              setIsCameraOpened((prevState) => !prevState)
              clickSound()
              // socket.emit('check-if-team-is-removed', TeamId)
              // socket.emit(
              //   'create-room',
              //   TeamId,
              //   30 * 60,
              //   '3b6ea349-844d-44e0-9cf7-30f01a8debfa',
              // )
            }}
            style={{
              backgroundColor: branding?.buttonPrimary.backgroundColor,
              color: branding?.buttonPrimary.textColor,
            }}
          />
          {showScore && (
            <div
              style={{
                // width: '95.5%',
                width: `calc(${window.innerWidth}px - 1.4rem)`,
                // width: '90%',
                position: 'absolute',
                bottom: '1.5rem',
                left: '1.2rem',
                backgroundColor: branding?.progress.backgroundColor,
                // left: '2rem',
                // left: '50%',
                // transform: 'translateX(-50%)',
              }}
              // onClick={() => setShowScore(false)}
              // className={`grid bg-white border-round ${
              //   showScore ? 'fadeinleft' : 'fadeoutleft'
              // } animation-duration-1000`}
              className={classNames(
                { fadeinleft: showScore, fadeoutleft: !showScore },
                'grid border-round animation-duration-1000',
              )}
            >
              <div className="col">
                <div className="flex justify-content-between align-items-center">
                  <div className="text-left">
                    <p
                      className="m-0"
                      style={{ color: branding?.progress.textColor }}
                    >
                      {t('SolvedPuzzles')}{' '}
                      <strong>
                        {progress?.solvedPuzzles}/{progress?.puzzlesCount}
                      </strong>
                    </p>
                    <small style={{ color: branding?.progress.primary }}>
                      <strong>{progress?.percentage}%</strong>
                    </small>
                  </div>
                  <div
                    style={{
                      background: branding?.progress.secondary,
                      color: branding?.progress.primary,
                      fontWeight: 'bold',
                    }}
                    className="p-2 border-round"
                  >
                    {progress?.score}
                  </div>
                </div>
                <ProgressBar
                  showValue={false}
                  className="mt-2"
                  value={progress?.percentage}
                  // unit="poits"
                  style={{ height: '.5rem' }}
                ></ProgressBar>
              </div>
              {/* <div className="col-4" onClick={() => setDisplayInventory(true)}>
                <div className="flex justify-content-between align-items-center">
                  <p className="m-0">Inventory</p>
                </div>
                <div
                  style={{
                    textAlign: 'left',
                    fontSize: '8vw',
                    color: 'var(--secondary-color)',
                  }}
                >
                  <strong>1/3</strong>
                </div>
              </div> */}
            </div>
          )}
        </div>
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: `calc(${window.innerHeight - height}px - 1rem)`,
            }}
          >
            <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
              <Scanner
                onScan={(results) => {
                  if (results && results.length > 0) {
                    const rawValue = results[0].rawValue
                    const questionId = rawValue.split(';')[0]
                    const puzzleTime = Number(rawValue.split(';')[1])

                    const checkIfPuzzleCanBeStarted = async () => {
                      await client
                        .get(
                          `Team/CheckIfPuzzleCanBeStartedAsync/${questionId}`,
                          {
                            headers: {
                              Authorization: `Bearer ${JSON.parse(token)}`,
                            },
                          },
                        )
                        .then((response) => {
                          if (response.data.data.canStart) {
                            socket.emit('check-if-team-is-removed', TeamId)
                            socket.emit(
                              'create-room',
                              TeamId,
                              puzzleTime * 60,
                              questionId,
                            )
                          } else {
                            dispatch(
                              showErrorNotification(
                                t(response.data.data.message),
                              ),
                            )
                          }
                        })
                    }

                    checkIfPuzzleCanBeStarted().catch((err) => {
                      Sentry.captureException(err)
                      dispatch(showErrorNotification(err))
                    })
                  }
                }}
                onError={(error) => {
                  console.info(error)
                }}
                constraints={{
                  facingMode: 'environment',
                }}
                styles={{
                  container: { width: '100%', height: '100%' },
                  video: { width: '100%', height: '100%', objectFit: 'cover' },
                }}
              />
            </div>
            <div className="px-3" style={{ flexShrink: 0 }}>
              <Button
                label={t('CloseCamera')}
                className="p-button-rounded my-2 w-full"
                ref={cameraBtnRef}
                icon={
                  <>
                    <div
                      className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                      style={{
                        backgroundColor: branding?.buttonPrimary.textColor,
                      }}
                    ></div>
                    <Logout
                      color={branding?.buttonPrimary.backgroundColor}
                      variant="Bold"
                      className="icon-center"
                    />
                  </>
                }
                onClick={() => {
                  setIsCameraOpened((prevState) => !prevState)
                  clickSound()
                }}
                style={{
                  backgroundColor: branding?.buttonPrimary.backgroundColor,
                  color: branding?.buttonPrimary.textColor,
                }}
              />
            </div>
          </div>
        </>
      )}
      {/* <div ref={elementRef2}>
        <TabMenu
          className="bottom-tabs"
          model={
            HasFinalPuzzle.toLowerCase() === 'true'
              ? items
              : items.filter((el) => el.label !== 'Inventory')
          }
          // onTabChange={(e) => setActiveIndex(e.index)}
        />
      </div> */}
      <Dialog
        header={() => {
          if (dialogData?.name) {
            switch (dialogData?.name) {
              case 'StartPuzzle':
                return t('FoundLocation')
              case 'LoadingGps':
                return t('CheckingLocationHeader')
              case 'PuzzleIsSolved':
                return t('PuzzleAlreadySolved')
              case 'NotOnLocation':
                return t('NotOnLocationHeader')
            }
          }
          return ''
        }}
        visible={displayCheckLocation}
        style={{ width: '90vw' }}
        // footer={renderFooter('displayCheckLocation')}
        onHide={() => onHide('displayCheckLocation')}
        headerStyle={{
          backgroundColor: branding?.modals.backgroundColor,
          color: branding?.modals.textColor,
        }}
      >
        {checkDialogData()}
      </Dialog>
    </div>
  )
}

export default Game
